import { forkJoin } from 'rxjs';

// admin-controls-dialog.component.ts
import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { DynamoDbService } from '../../services/dynamodb.service';
import { ControlData } from '../../shared/app-consts';
import { AccountData } from '../tables/tables.component';

@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.sass']
})
export class ChangeStatusComponent {
  selectedTeam: string = '';
  selectedControlIds: string[] = [];
  controlPoints: number = 0;
  teamPoints: number = 0;

  #ddb = inject(DynamoDbService);
  #snackBar = inject(MatSnackBar);

  constructor(
    public dialogRef: MatDialogRef<ChangeStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      accountData: AccountData[],
      controlStatus: { [accountID: string]: ControlData[] }
    }
  ) { }

  getControlsForFirstTeam(): ControlData[] {
    const firstTeamAccountId = this.data.accountData[0]?.AccountID;
    return firstTeamAccountId ? this.data.controlStatus[firstTeamAccountId] : [];
  }

  doneControl(): void {
    const requests = this.selectedControlIds.map(controlId => this.#ddb.doneControl(this.selectedTeam, controlId));
    forkJoin(requests).subscribe({
      next: () => {
        this.#snackBar.open(`${this.selectedTeam}の${this.selectedControlIds.join(', ')}を準拠にしました`, 'Close', {
          duration: 3000,
        });
      },
      error: (error) => {
        console.error('doneControl error', error);
        this.#snackBar.open(`${this.selectedTeam}の${this.selectedControlIds.join(', ')}の準拠に失敗しました`, 'Close', {
          duration: 3000,
        });
      }
    });
  }
  undoneControl(): void {
    const requests = this.selectedControlIds.map(controlId => this.#ddb.undoneControl(this.selectedTeam, controlId));
    forkJoin(requests).subscribe({
      next: () => {
        this.#snackBar.open(`${this.selectedTeam}の${this.selectedControlIds.join(', ')}を非準拠にしました`, 'Close', {
          duration: 3000,
        });
      },
      error: (error) => {
        console.error('undoneControl error', error);
        this.#snackBar.open(`${this.selectedTeam}の${this.selectedControlIds.join(', ')}の非準拠に失敗しました`, 'Close', {
          duration: 3000,
        });
      }
    });
  }



  assignTeamPoints(): void {
    console.log('Assign team points:', this.selectedTeam, this.teamPoints);
    this.#ddb.assignTeamPoints(this.selectedTeam, this.teamPoints).subscribe({
      next: () => {
        this.#snackBar.open(`${this.selectedTeam}に${this.teamPoints}ポイントを割り当てました`, 'Close', {
          duration: 3000,
        });
      },
      error: (error) => {
        console.error('assignTeamPoints error', error);
        this.#snackBar.open(`${this.selectedTeam}のポイントの割り当てに失敗しました`, 'Close', {
          duration: 3000,
        });
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}